import React from "react";
import {
  Box,
  CenterSingle,
  Cluster,
  Heading,
  Paragraph,
  withWindowSize,
  constants,
} from "@thecb/components";
import MaintenanceIcon from "./MaintenanceIcon";
import { BACKGROUND_DIM } from "@/constants/colors";

const MaintenancePage = () => (
  <Box
    padding="64px"
    extraStyles={`
    display: flex;
    flex-direction: column;
    height: 100%;
  `}
  >
    <CenterSingle
      backgroundColor={BACKGROUND_DIM}
      content={
        <Box padding="0" textAlign="center">
          <Cluster justify="center">
            <MaintenanceIcon />
            <Heading
              variant="h4"
              color={constants.colors.BLACK}
              weight="600"
              as="h1"
              margin="24px 0 8px"
            >
              Down For Maintenance
            </Heading>
            <Paragraph variant="pL" color={constants.colors.BLACK}>
              Revenue Management is down for maintenance. Please try again later.
            </Paragraph>
          </Cluster>
        </Box>
      }
    />
  </Box>
);

export default withWindowSize(MaintenancePage);
